import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../shared/AppConfig';
import { ApiResponse } from '../models/ApiResponse';
import { USerNotification } from '../models/SelectItems';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgentService {

  protected _appset = AppConfig.settings;
  constructor(private http: HttpClient) { }

  async GetAuthKeyConfiguration(userid: any) {
    return this.http.get<ApiResponse>(`${environment.APIUrl}agent/GetAuthKeyConfiguration?userid=`+userid, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async UpdateAuthKeyConfiguration(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}agent/UpdateAuthKeyConfiguration`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async RemoveAuthKey(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}agent/RemoveAuthKey`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }
  
  async GenerateAuthenticationKey(data: any) {
    return this.http.post<ApiResponse>(`${environment.APIUrl}agent/GenerateAuthenticationKey`, data, {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: any) => {
      return errorRes;
    });   
  }

  async GetAgentStatus(userId:any) {
    return this.http.get<ApiResponse>(`${environment.APIUrl}agent/GetAgentStatus?userId=`+userId,  {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
    }).toPromise().catch(async (errorRes: ApiResponse) => {
      let res = new ApiResponse();
      res.isSuccess = false;
      res.message = errorRes.message;
      return res;
    });
  }
  
  async DownloadCertificate(userId:any) {
      return this.http.get<ApiResponse>(`${environment.WebPortalAPIUrl}agent/DownloadCertificate?id=`+userId,  {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
      }).toPromise().catch(async (errorRes: ApiResponse) => {
        let res = new ApiResponse();
        res.isSuccess = false;
        res.message = errorRes.message;
        return res;
      });
    }
}
